import { Component, OnInit } from '@angular/core';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { BaseModalComponent } from '../../base-modal.component';
import { UnsupportedCase } from '../../../../classes/UnsupportedUseCases';
import { UnsupportedUseCasesService } from '../../../../services/unsupportedUseCases/unsupportedUseCases.service';

@Component({
  moduleId: module.id,
  selector: 'group-replacement',
  templateUrl: './group-replacement.component.html',
})
export class GroupReplacementComponent extends BaseModalComponent implements OnInit {
  data;
  policyNumber;
  constructor(modalService: ModalService) {
    super(modalService);
  }

  ngOnInit() {
    this.policyNumber = this.data.existingPolicy.number;
  }

  //on Yes
  confirm() {
    this.data.existingPolicy.isGroupPolicy = true;
    this.modalService.deactivate();
  }

  //on No
  cancel() {
    this.data.existingPolicy.isGroupPolicy = false;
    this.modalService.deactivate();
  }
}
